import styled from "@emotion/styled";

import SkeletonCaption from "metabase/visualizations/components/skeletons/SkeletonCaption";

export const VisualizationSkeletonCaption = styled(SkeletonCaption)`
  justify-content: space-between;
`;
